import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';

// project import
import Header from './Header';
import navigation from '../../menu-items';
import Loader from '../../components/Loader';
import Breadcrumbs from '../../components/@extended/Breadcrumbs';

import { handlerDrawerOpen, useGetMenuMaster } from '../../api/menu';

// ==============================|| MAIN LAYOUT - MODERN ||============================== //

export default function DashboardLayout() {
  const theme = useTheme();
  const location = useLocation();
  const { menuMasterLoading } = useGetMenuMaster();
  const downXL = useMediaQuery((theme) => theme.breakpoints.down('xl'));
  const isExamTakingRoute = location.pathname.startsWith('/exam-test/') || location.pathname.startsWith('/part-test/');
  const hideBreadcrumbs = isExamTakingRoute;

  useEffect(() => {
    handlerDrawerOpen(!downXL);
  }, [downXL]);

  if (menuMasterLoading) return <Loader />;

  return (
    <Box sx={{ display: 'flex', width: '100%', minHeight: '100vh' }}>
      {!isExamTakingRoute && <Header />}
      <Box component="main" sx={{
        width: isExamTakingRoute ? '100%' : 'calc(100% - 260px)',
        flexGrow: 1,
        p: 0,
        backgroundColor: theme.palette.background.default
      }}>
        <Toolbar sx={{ minHeight: { xs: 92, sm: 108 } }} />
        {!hideBreadcrumbs && <Breadcrumbs navigation={navigation} title />}
        <Box sx={{ px: { xs: 2, sm: 3 }, pt: hideBreadcrumbs ? { xs: 0.75, sm: 1 } : { xs: 1, sm: 1.25 }, pb: { xs: 2, sm: 3 } }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
